export const DEFAULT_LOCALE = 'en-US';
export const IS_LOCALISATION_FEATURE_ENABLED =
  'IS_LOCALISATION_FEATURE_ENABLED';
